import axios from "axios";
import Cookies from "universal-cookie";
import { COMPANY_ID, TOKEN_NAME, config, PRODUCT_SLUG } from "../config";
const cookies = new Cookies();
const company_id = cookies.get(COMPANY_ID);

export const getholidayList = async () => {
  let token = cookies.get(TOKEN_NAME);
  var res = await axios({
    method: "GET",
    url: `${config.apiurl}holidaylist`,
    headers: { Authorization: token ? `Bearer ${token}` : "" },
  });
  return await res.data;
};

export const postHolidayForm = async (data) => {
  let token = cookies.get(TOKEN_NAME);
  const company_id = cookies.get(COMPANY_ID);

  var form_data = new FormData();
  for (var key in data) {
    if (Array.isArray(data[key])) {
      form_data.append(key, JSON.stringify(data[key]));
    } else {
      form_data.append(key, data[key]);
    }
  }

  if (company_id) {
    form_data.append("company_id", company_id);
    form_data.append("product_slug", PRODUCT_SLUG);
  }

  var res = await axios({
    method: "POST",
    url: `${config.apiurl}holiday_save`,
    data: form_data,
    headers: { Authorization: token ? `Bearer ${token}` : "" },
  });
  return res;
};

export const postLeaveManagementForm = async (data) => {
  let token = cookies.get(TOKEN_NAME);
  var form_data = new FormData();
  form_data.append("company_id", cookies.get(COMPANY_ID));
  form_data.append("product_slug", PRODUCT_SLUG);
  for (var key in data) {
    if (Array.isArray(data[key])) {
      form_data.append(key, JSON.stringify(data[key]));
    } else {
      form_data.append(key, data[key]);
    }
  }
  var res = await axios({
    method: "POST",
    url: `${config.apiurl}createUserLeaveManagement`,
    data: form_data,
    headers: { Authorization: token ? `Bearer ${token}` : "" },
  });
  return res;
};

export const updateHolidayForm = async (data, id) => {
  let token = cookies.get(TOKEN_NAME);
  var form_data = new FormData();
  for (var key in data) {
    if (Array.isArray(data[key])) {
      form_data.append(key, JSON.stringify(data[key]));
    } else {
      form_data.append(key, data[key]);
    }
  }
  // form_data.append('id', id);
  var res = await axios({
    method: "POST",
    url: `${config.apiurl}holiday_update`,
    data: form_data,
    headers: { Authorization: token ? `Bearer ${token}` : "" },
  });
  return res;
};

export const deleteHolidayForm = async (id) => {
  let token = cookies.get(TOKEN_NAME);
  let companyId = cookies.get(COMPANY_ID);

  var form_data = new FormData();
  form_data.append("id", id);
  form_data.append("company_id", companyId);
  form_data.append("product_slug", PRODUCT_SLUG);

  var res = await axios({
    method: "POST",
    url: `${config.apiurl}holiday_delete`,
    data: form_data,
    headers: { Authorization: token ? `Bearer ${token}` : "" },
  });

  return res;
};
export const deleteLeaveManagement = async (
  id,
  company_id,
  company_employee_id
) => {
  let token = cookies.get(TOKEN_NAME);
  var form_data = new FormData();
  form_data.append("id", id);
  form_data.append("company_id", company_id);
  form_data.append("product_slug", PRODUCT_SLUG);
  form_data.append("company_employee_id", company_employee_id);
  var res = await axios({
    method: "POST",
    url: `${config.apiurl}deleteUserLeaveManagement`,
    data: form_data,
    headers: { Authorization: token ? `Bearer ${token}` : "" },
  });
  return res;
};
